module.exports = __webpack_public_path__ + "static/media/pic8.828ca9e1.jpg";